import { createSelector } from "reselect";

const getNavigationState = (state) => state.navigation;

export const getIsNavigationDisplayed = createSelector([ getNavigationState ], navigation => navigation.isDisplayed);